// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EventsModal_modal__Q6\\+J\\+ {
  background-color: rgba(0, 0, 0, 0.78);
  padding: 0;
}
@media (min-width: 576px) {
  .EventsModal_modal__Q6\\+J\\+ {
    padding: 0 40px;
  }
}
.EventsModal_modal__Q6\\+J\\+ .modal__inner {
  max-width: none;
  border-radius: 0;
  position: static;
  background: none;
}
@media (min-width: 576px) {
  .EventsModal_modal__Q6\\+J\\+ .modal__inner {
    max-width: 540px;
  }
}
.EventsModal_modal__Q6\\+J\\+ .modal__body {
  height: 100dvh;
  position: relative;
  padding: 0;
}
.EventsModal_modal__Q6\\+J\\+ .modal__close-btn {
  top: 50px;
  right: 20px;
  width: 20px;
  height: 20px;
  color: var(--white);
  background-color: rgba(0, 0, 0, 0.12);
  z-index: 3;
}
@media (min-width: 576px) {
  .EventsModal_modal__Q6\\+J\\+ .modal__close-btn {
    top: 24px;
    right: 24px;
  }
}
@media (hover: hover) {
  .EventsModal_modal__Q6\\+J\\+ .modal__close-btn:hover {
    background-color: rgb(0, 0, 0);
  }
}
.EventsModal_modal__Q6\\+J\\+ .modal__close-btn svg {
  max-width: 8px;
  max-height: 8px;
}
.EventsModal_modal--is-force-view__NhZBR .slider-next-btn,
.EventsModal_modal--is-force-view__NhZBR .slider-prev-btn,
.EventsModal_modal--is-force-view__NhZBR .modal__overlay,
.EventsModal_modal--is-force-view__NhZBR .events.pag,
.EventsModal_modal--is-force-view__NhZBR .swiper {
  pointer-events: none;
}

.EventsModal_slider__2jioM {
  width: 100%;
}

.EventsModal_slide__mz\\+x9 {
  height: 100dvh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: var(--white);
  overflow: hidden;
}
@media (min-width: 576px) {
  .EventsModal_slide__mz\\+x9 {
    border-radius: 12px;
    height: calc(100vh - 94px);
  }
}

.EventsModal_img__wLveH {
  width: 540px;
  max-height: 100%;
  aspect-ratio: 540/780;
}

.EventsModal_content__iTnPA {
  position: relative;
  padding: 24px 24px 50px;
}
@media (min-width: 576px) {
  .EventsModal_content__iTnPA {
    padding: 24px 32px 24px;
  }
}
.EventsModal_content__iTnPA::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(100% + 94px);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0) 100%);
}
@media (min-width: 576px) {
  .EventsModal_content__iTnPA::before {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.1) 60%, rgba(0, 0, 0, 0) 100%);
  }
}

.EventsModal_title__NALeF,
.EventsModal_txt__wT3ZT {
  position: relative;
}

.EventsModal_title__NALeF {
  font-size: 32px;
  line-height: 36px;
  font-weight: 700;
}
@media (min-width: 576px) {
  .EventsModal_title__NALeF {
    font-size: 24px;
    line-height: 28px;
    font-weight: 500;
  }
}

.EventsModal_txt__wT3ZT {
  font-size: 18px;
  line-height: 26px;
  margin-top: 8px;
  white-space: pre-line;
}
@media (min-width: 576px) {
  .EventsModal_txt__wT3ZT {
    font-size: 14px;
    line-height: 16px;
    margin-top: 6px;
  }
}

.EventsModal_pag__5RRmI {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 47px;
  display: flex;
  align-items: center;
  grid-gap: 0 8px;
  z-index: 2;
  padding: 0 12px;
}
@media (min-width: 576px) {
  .EventsModal_pag__5RRmI {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
  }
}
.EventsModal_pag__5RRmI::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 94px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);
  pointer-events: none;
}
@media (min-width: 576px) {
  .EventsModal_pag__5RRmI::before {
    display: none;
  }
}

.EventsModal_pagItem__MiJt3 {
  width: 100%;
  height: 2px;
  background-color: rgba(255, 255, 255, 0.48);
  border-radius: 33px;
  position: relative;
  overflow: hidden;
}
.EventsModal_pagItem__MiJt3 span {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: var(--white);
}

div.EventsModal_nav__ZAiU8 {
  position: absolute;
  left: -72px;
  right: -72px;
  top: calc(50% - 36px);
  display: none;
}
@media (min-width: 768px) {
  div.EventsModal_nav__ZAiU8 {
    display: flex;
  }
}
div.EventsModal_nav__ZAiU8 .swiper-button-disabled {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/EventsModal/EventsModal.module.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;EACA,UAAA;AACF;AACE;EAJF;IAKI,eAAA;EAEF;AACF;AAEM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AAEQ;EANF;IAOI,gBAAA;EACR;AACF;AAEM;EACE,cAAA;EACA,kBAAA;EACA,UAAA;AAAR;AAGM;EACE,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qCAAA;EACA,UAAA;AADR;AAGQ;EATF;IAUI,SAAA;IACA,WAAA;EAAR;AACF;AAEQ;EACE;IACE,8BAAA;EAAV;AACF;AAGQ;EACE,cAAA;EACA,eAAA;AADV;AASM;;;;;EAKE,oBAAA;AAPR;;AAaA;EACE,WAAA;AAVF;;AAaA;EACE,cAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAVF;AAYE;EAXF;IAYI,mBAAA;IACA,0BAAA;EATF;AACF;;AAYA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;AATF;;AAYA;EACE,kBAAA;EACA,uBAAA;AATF;AAWE;EAJF;IAKI,uBAAA;EARF;AACF;AAUE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,uGAAA;AARJ;AAUI;EATF;IAUI,uGAAA;EAPJ;AACF;;AAWA;;EAEE,kBAAA;AARF;;AAWA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AARF;AAUE;EALF;IAMI,eAAA;IACA,iBAAA;IACA,gBAAA;EAPF;AACF;;AAUA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;AAPF;AASE;EANF;IAOI,eAAA;IACA,iBAAA;IACA,eAAA;EANF;AACF;;AASA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,eAAA;AANF;AAQE;EAZF;IAaI,kBAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;EALF;AACF;AAOE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,iFAAA;EACA,oBAAA;AALJ;AAOI;EAVF;IAWI,aAAA;EAJJ;AACF;;AAQA;EACE,WAAA;EACA,WAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AALF;AAOE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,8BAAA;AALJ;;AASA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;AANF;AAQE;EAPF;IAQI,aAAA;EALF;AACF;AAQI;EACE,aAAA;AANN","sourcesContent":[".modal {\r\n  background-color: rgba(0,0,0,0.78);\r\n  padding: 0;\r\n\r\n  @media (min-width: 576px) {\r\n    padding: 0 40px;\r\n  }\r\n\r\n  :global {\r\n    .modal {\r\n      &__inner {\r\n        max-width: none;\r\n        border-radius: 0;\r\n        position: static;\r\n        background: none;\r\n\r\n        @media (min-width: 576px) {\r\n          max-width: 540px;\r\n        }\r\n      }\r\n\r\n      &__body {\r\n        height: 100dvh;\r\n        position: relative;\r\n        padding: 0;\r\n      }\r\n\r\n      &__close-btn {\r\n        top: 50px;\r\n        right: 20px;\r\n        width: 20px;\r\n        height: 20px;\r\n        color: var(--white);\r\n        background-color: rgba(0,0,0,0.12);\r\n        z-index: 3;\r\n\r\n        @media (min-width: 576px) {\r\n          top: 24px;\r\n          right: 24px;\r\n        }\r\n\r\n        @media (hover: hover) {\r\n          &:hover {\r\n            background-color: rgba(0,0,0,1);\r\n          }\r\n        }\r\n\r\n        svg {\r\n          max-width: 8px;\r\n          max-height: 8px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &--is-force-view {\r\n    :global {\r\n      .slider-next-btn,\r\n      .slider-prev-btn,\r\n      .modal__overlay,\r\n      .events.pag,\r\n      .swiper {\r\n        pointer-events: none;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.slider {\r\n  width: 100%;\r\n}\r\n\r\n.slide {\r\n  height: 100dvh;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-end;\r\n  color: var(--white);\r\n  overflow: hidden;\r\n\r\n  @media (min-width: 576px) {\r\n    border-radius: 12px;\r\n    height: calc(100vh - 94px);\r\n  }\r\n}\r\n\r\n.img {\r\n  width: 540px;\r\n  max-height: 100%;\r\n  aspect-ratio: 540 / 780;\r\n}\r\n\r\n.content {\r\n  position: relative;\r\n  padding: 24px 24px 50px;\r\n\r\n  @media (min-width: 576px) {\r\n    padding: 24px 32px 24px;\r\n  }\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    height: calc(100% + 94px);\r\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.2) 60%, rgba(0, 0, 0, 0) 100%);\r\n\r\n    @media (min-width: 576px) {\r\n      background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.1) 60%, rgba(0, 0, 0, 0) 100%);\r\n    }\r\n  }\r\n}\r\n\r\n.title,\r\n.txt {\r\n  position: relative;\r\n}\r\n\r\n.title {\r\n  font-size: 32px;\r\n  line-height: 36px;\r\n  font-weight: 700;\r\n\r\n  @media (min-width: 576px) {\r\n    font-size: 24px;\r\n    line-height: 28px;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.txt {\r\n  font-size: 18px;\r\n  line-height: 26px;\r\n  margin-top: 8px;\r\n  white-space: pre-line;\r\n\r\n  @media (min-width: 576px) {\r\n    font-size: 14px;\r\n    line-height: 16px;\r\n    margin-top: 6px;\r\n  }\r\n}\r\n\r\n.pag {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  height: 47px;\r\n  display: flex;\r\n  align-items: center;\r\n  grid-gap: 0 8px;\r\n  z-index: 2;\r\n  padding: 0 12px;\r\n\r\n  @media (min-width: 576px) {\r\n    position: relative;\r\n    left: auto;\r\n    right: auto;\r\n    top: auto;\r\n  }\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    height: 94px;\r\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%);\r\n    pointer-events: none;\r\n\r\n    @media (min-width: 576px) {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.pagItem {\r\n  width: 100%;\r\n  height: 2px;\r\n  background-color: rgba(255,255,255,0.48);\r\n  border-radius: 33px;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  span {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    height: 100%;\r\n    background-color: var(--white);\r\n  }\r\n}\r\n\r\ndiv.nav {\r\n  position: absolute;\r\n  left: -72px;\r\n  right: -72px;\r\n  top: calc(50% - 36px);\r\n  display: none;\r\n\r\n  @media (min-width: 768px) {\r\n    display: flex;\r\n  }\r\n\r\n  :global {\r\n    .swiper-button-disabled {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `EventsModal_modal__Q6+J+`,
	"modal--is-force-view": `EventsModal_modal--is-force-view__NhZBR`,
	"slider": `EventsModal_slider__2jioM`,
	"slide": `EventsModal_slide__mz+x9`,
	"img": `EventsModal_img__wLveH`,
	"content": `EventsModal_content__iTnPA`,
	"title": `EventsModal_title__NALeF`,
	"txt": `EventsModal_txt__wT3ZT`,
	"pag": `EventsModal_pag__5RRmI`,
	"pagItem": `EventsModal_pagItem__MiJt3`,
	"nav": `EventsModal_nav__ZAiU8`
};
export default ___CSS_LOADER_EXPORT___;
